export {};
//# sourceMappingURL=expose-current-frame-and-current-time-factory.js.map